import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { buildApiUrl } from '../../../utils/apiUrl';
import BarChartComponent from './data/dashChartData';
import StatisticsModal from './StatisticsModal';
import CustomStatistics from './CustomStatistics';

// Icons
import { BsGraphUp } from 'react-icons/bs';
import { FaRegMoneyBillAlt, FaWpforms } from 'react-icons/fa';
import { LuUser } from 'react-icons/lu';
import { RiAdminLine } from 'react-icons/ri';

import { TiStarFullOutline } from 'react-icons/ti';
// SCSS
import '../../../assets/scss/Admin/Dashboard.scss';

const Dashboard = () => {
	const [stats, setStats] = useState({
		users: 0,
		userRoleUser: 0,
		userRoleAdmin: 0,
		ordersSent: 0,
		formsMonth: 0,
		mostFirm: '',
		userMostOrders: '',
	});
	const [reviews, setReviews] = useState([]);
	const [showStatsModal, setShowStatsModal] = useState(false);
	const [showCustomStats, setShowCustomStats] = useState(false);
	const [customStatsData, setCustomStatsData] = useState(null);
	const [customStatsFilters, setCustomStatsFilters] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const [userStats, orderStats, monthlyStats] = await Promise.all(
					[
						axios.get(buildApiUrl('statistics/user-stats')),
						axios.get(buildApiUrl('statistics/order-stats')),
						axios.get(buildApiUrl('statistics/monthly-order-stats')),
					]
				);

				setStats({
					users: parseInt(userStats.data.userCount),
					userRoleUser: parseInt(userStats.data.userCount),
					userRoleAdmin: parseInt(
						userStats.data.adminAndSuperAdminCount
					),
					ordersSent: parseInt(orderStats.data.totalOrders),
					formsMonth: parseInt(monthlyStats.data.monthlyOrderCount),
					mostFirm: monthlyStats.data.mostFrequentCompanyName,
					userMostOrders: monthlyStats.data.mostFrequentOrdererName,
				});
			} catch (error) {
				console.error('Error fetching dashboard data:', error);
			}
		};

		const fetchReviews = async () => {
			try {
				const response = await axios.get(
					buildApiUrl('reviews/getReviews')
				);
				setReviews(response.data);
				console.log(response.data);
			} catch (error) {
				console.error('Error fetching reviews:', error);
			}
		};

		fetchData();
		fetchReviews();
	}, []);

	const handleGenerateStats = async (filters) => {
		try {
			const response = await axios.post(
				buildApiUrl('statistics/custom-stats'),
				filters
			);
			setCustomStatsData(response.data);
			setCustomStatsFilters(filters);
			setShowStatsModal(false);
			setShowCustomStats(true);
		} catch (error) {
			console.error('Error generating custom stats:', error);
		}
	};

	if (showCustomStats && customStatsData) {
		return (
			<CustomStatistics
				stats={customStatsData}
				filters={customStatsFilters}
				onBack={() => setShowCustomStats(false)}
			/>
		);
	}

	return (
		<div className='dashboard'>
			<div className='dashboard-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
				<h3>Du er nå inne i Admin oversikten</h3>
				<button
					onClick={() => setShowStatsModal(true)}
					style={{
						backgroundColor: '#005379',
						color: 'white',
						border: 'none',
						padding: '10px 20px',
						borderRadius: '5px',
						cursor: 'pointer',
						fontWeight: 'bold'
					}}
				>
					Lag statistikk
				</button>
			</div>
			{showStatsModal && (
				<StatisticsModal
					onClose={() => setShowStatsModal(false)}
					onGenerate={handleGenerateStats}
				/>
			)}
			<div className='dashboard__content'>
				<div className='topStats'>
					<div className='stats-card'>
						<div className='col'>
							<LuUser size='32' />
							<h3>Brukere registrert</h3>
						</div>
						<div className='stats-number'>
							<p>{stats.users}</p>
						</div>
					</div>

					<div className='stats-card'>
						<div className='col'>
							<RiAdminLine size='32' />
							<h3>Admin brukere</h3>
						</div>
						<div className='stats-number'>
							<p>{stats.userRoleAdmin}</p>
						</div>
					</div>

					<div className='stats-card'>
						<div className='col'>
							<FaWpforms size='32' />
							<h3>Ordre sendt</h3>
						</div>
						<div className='stats-number'>
							<p>{stats.ordersSent}</p>
						</div>
					</div>
				</div>

				<div className='middleStats'>
					<div className='middleStats__content row'>
						<div className='dailyReports'>
							<div className='top row'>
								<div className='col'>
									<h3>Månedlig rapport</h3>
									<p>The Assessment Company</p>
								</div>
								<BsGraphUp size='32' />
							</div>
							<div className='dailyReports__content'>
								<BarChartComponent />
							</div>
						</div>

						<div className='statsReport'>
							<div className='top row'>
								<div className='col'>
									<h3>Statistikk denne mnd</h3>
									<p>The Assessment Company</p>
								</div>
								<FaRegMoneyBillAlt size='32' />
							</div>
							<div className='statsReport__content'>
								<div className='row'>
									<div className='col'>
										<div className='col new-item'>
											<h3>Antall skjema</h3>
											<p>{stats.formsMonth}</p>
										</div>
									</div>
									<div className='col'>
										<div className='col new-item'>
											<h3>Største firma</h3>
											<p>{stats.mostFirm}</p>
										</div>
										<div className='col new-item'>
											<h3>Flest bestillinger</h3>
											<p>{stats.userMostOrders}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='review-stats'>
					<h2>Tilbakemeldinger fra kunde</h2>
					<div className='review-stats__content'>
						{reviews.map((review) => (
							<div className='review' key={review.id}>
								<div className='flex-row'>
									<div className='annonselosninger'>
										<p>Annonseløsninger</p>
										<p>
											{review.rating_annonseløsninger} av
											5 <TiStarFullOutline />
										</p>
									</div>
									<div className='bestillingsskjema'>
										<p>Bestillingsskjema</p>
										<p>
											{review.rating_bestillingsskjema} av
											5 <TiStarFullOutline />
										</p>
									</div>
								</div>
								<div className='text'>{review.review_text}</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
